module.exports = __webpack_public_path__ + "static/media/report_confused_white.1b6a51b7.svg";